import { setNotifications,setUnseenNotifCount } from "../actions";

export const fetchUserNotifications = () => (dispatch,getState) => {
    const token = window.localStorage.getItem('token');
    console.log(getState(),token)
        fetch("https://recruitingmonk-v2.azurewebsites.net/notifications", {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token,
          },
          method: "POST",
          body: JSON.stringify({
            uid: getState().info.info.uid,
            username: getState().info.info.username,
          }),
        })
          .then((response) => {
            if (response.ok) {
              return response;
            } else {
              var error = new Error(
                "Error " + response.status + ": " + response.statusText
              );
              error.response = response;
              throw error;
            }
          })
          .then((res) => res.json())
          .then((response) => {
            if (response.success) {
              console.log("Notifications fetched!")
              dispatch(setNotifications(response.notifications));
              let unseenNotifs = response.notifications.filter((notification) => {
                // let recipient = notification.recipients.find(
                //   (recipient) => recipient.user === getState().info.info.uid
                // );
                return notification.recipients[0]?.user &&
                  !notification.recipients[0].seen
                  ? true
                  : false;
              });
              dispatch(setUnseenNotifCount(unseenNotifs?.length || 0));
            }
          }).catch(error => {
              console.log(error)
          })
          ;
}